'use es6';

import { View } from 'foundations-components/transitional/components/View';
import PropTypes from 'prop-types';
import CalloutTypeList from './CalloutTypeList';
import { jsx as _jsx } from "react/jsx-runtime";
function CalloutInsertPopoverBody(props) {
  const {
    onInsertCallout
  } = props;
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "0",
    paddingBlock: "100",
    as: "div",
    children: /*#__PURE__*/_jsx(CalloutTypeList, {
      paddingInline: "500",
      onClick: onInsertCallout
    })
  });
}
CalloutInsertPopoverBody.propTypes = {
  onInsertCallout: PropTypes.func.isRequired
};
export default CalloutInsertPopoverBody;